import { useState } from "react";
import { Link } from "react-router-dom";
import { AttributionLink } from "@/components/AttributionLink";
import { AuthBrand } from "@/components/auth/AuthBrand";
import { AuthForm } from "@/components/auth/AuthForm";
import { AuthHero } from "@/components/auth/AuthHero";

export const AuthPage = () => {
  const [mode, setMode] = useState("login");
  const isRegistering = mode === "register";

  return (
    <main className="min-h-screen bg-[#F9F6F0]" data-testid="auth-page">
      <div className="grid min-h-screen lg:grid-cols-[1.05fr_0.95fr]">
        <AuthHero />

        <section className="flex items-center px-4 py-12 sm:px-8 lg:px-16" data-testid="auth-form-section">
          <div className="mx-auto w-full max-w-md gentle-reveal">
            <AuthBrand />

            <div className="mb-8" data-testid="auth-copy-block">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C9B90]" data-testid="auth-mode-label">{isRegistering ? "Begin" : "Return"}</p>
              <h2 className="mt-3 font-serif-display text-4xl font-semibold text-[#1A3626]" data-testid="auth-form-heading">
                {isRegistering ? "Create your account" : "Sign in to reflect"}
              </h2>
            </div>

            <AuthForm mode={mode} />

            <button
              type="button"
              data-testid="auth-mode-toggle-button"
              onClick={() => setMode(isRegistering ? "login" : "register")}
              className="mt-6 w-full rounded-full px-4 py-3 text-sm font-medium text-[#4A5D4E] transition-colors duration-300 hover:bg-white hover:text-[#1A3626]"
            >
              {isRegistering ? "Already have an account? Sign in" : "New here? Create an account"}
            </button>
            <Link
              to="/resources"
              data-testid="auth-resources-link"
              className="mt-2 block rounded-full px-4 py-3 text-center text-sm font-medium text-[#4A5D4E] transition-colors duration-300 hover:bg-white hover:text-[#1A3626]"
            >
              View DailyDevo resources
            </Link>
            <AttributionLink className="mt-8" />
          </div>
        </section>
      </div>
    </main>
  );
};